module.exports = __webpack_public_path__ + "static/media/carousel2.70c70b88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/others/carousel2.png
// module id = 1227
// module chunks = 0